import { AnalyticsEventName, FeatureFlags } from '@dupe/common/constants'
import { motion } from 'framer-motion'
import Image from 'next/image'
import Button from '~/src/components/Button'
import OnboardingTitle from '~/src/components/onboarding/OnboardingTitle'
import useAnalytics from '~/src/hooks/useAnalytics'
import useIsFeatureOn from '~/src/hooks/useIsFeatureOn'
import {
  OnboardingStep,
  useOnboardingActions,
} from '~/src/stores/useOnboardingStore'

const DupeValuePropTwoStep: React.FC = () => {
  const analytics = useAnalytics()
  const { featureOn: paywallEnabled } = useIsFeatureOn(
    FeatureFlags.OnboardingPaywallStep
  )
  const nextStep = useOnboardingActions().nextStep
  const markStepComplete = useOnboardingActions().markStepComplete

  const handleContinue = async () => {
    analytics.track(AnalyticsEventName.AuthModalOnboardingSubmit, {
      step: 'value-prop-two',
    })

    if (paywallEnabled) {
      markStepComplete(OnboardingStep.DUPE_VALUE_PROP_TWO)
      nextStep(OnboardingStep.PAYWALL)
    } else {
      markStepComplete(OnboardingStep.DUPE_VALUE_PROP_TWO)
      nextStep(OnboardingStep.COMPLETE)
    }
  }

  return (
    <div className='space-y-4 md:space-y-12'>
      <OnboardingTitle
        title='Time is money, and good news, we save you both! '
        description='A dirty little secret, a lot of the furniture you see online is white labeled and overpriced. Using our strategies Dupe users typically save 60% or more.'
      />

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ delay: 0.3 }}
        className='flex-1 rounded-lg bg-white p-3 md:flex-none'
      >
        <Image
          src='/assets/onboarding/value-prop-2.png'
          alt='Dupe Value Prop Two'
          width={450}
          height={256}
          className='mx-auto'
        />
      </motion.div>

      <Button onClick={() => handleContinue()} fullWidth>
        Continue
      </Button>
    </div>
  )
}

export default DupeValuePropTwoStep
